module.exports = __webpack_public_path__ + "img/0-49.d72b235e.jpg";